module.exports = __webpack_public_path__ + "static/media/seb.5d6e2877.png";